<template>
    <div id="footer" class="acea-row row-middle" style="background-color:#17a4f4">
        <router-link
                :to="item.url"
                class="item"
                :class="{ on: item.url === $route.path }"
                v-for="(item, index) in footerList"
                :key="index"
        >
            <!--      <div-->
            <!--        class="iconfont"-->
            <!--        :class="item.icon1 + ' ' + (item.url === $route.path ? item.icon2 : '')"-->
            <!--      ></div>-->
            <!--      <div>-->
            <!--          <el-image src="@assets/images/classChannel/icon/grb.png"-->
            <!--                  :fit="fit">-->

            <!--          </el-image>-->
            <!--      </div>-->
            <div class="iconfont">
                <img :src="getThumb(item.src1,item.src2,item.url === $route.path)" style="height: 3vh"/>
            </div>

            <div><font :color="getColor(item.url === $route.path)">{{ item.name }}</font></div>
        </router-link>
    </div>
</template>
<script>

    export default {
        name: "Footer",
        props: {},
        data: function () {
            return {
                font_color:"white",
                footerList: [
                    {
                        name: "学习频道",
                        icon1: "icon-yingyongchengxu-xianxing",
                        icon2: "icon-yingyongchengxu",
                        src1: "xxpd",
                        src2: "xxpd_new",
                        url: "/lessons"
                    },
                    {
                        name: "光荣榜",
                        icon1: "icon-shouye-xianxing",
                        icon2: "icon-shouye",
                        url: "/Billboard",
                        src1: "grb",
                        src2: "grb_new",
                    },
                    {
                        name: "积分商城",
                        icon1: "icon-caigou-xianxing",
                        icon2: "icon-caigou",
                        url: "/category",
                        src1: "jfsc",
                        src2: "jfsc_new",
                    },
                    {
                        name: "我的",
                        icon1: "icon-yonghu-xianxing",
                        icon2: "icon-yonghu",
                        url: "/user",
                        src1: "wd",
                        src2: "wd_new",
                    }
                ]
            };
        },
        methods: {
            getThumb(type,type1,ck) {
                let thumb = {
                    xxpd: require("@assets/images/classChannel/icon/xxpd.png"),
                    grb:require("@assets/images/classChannel/icon/grb.png"),
                    jfsc:require("@assets/images/classChannel/icon/jfsc.png"),
                    wd:require("@assets/images/classChannel/icon/wd.png"),
                    xxpd_new: require("@assets/images/classChannel/icon/xxpd-new.png"),
                    grb_new:require("@assets/images/classChannel/icon/grb-new.png"),
                    jfsc_new:require("@assets/images/classChannel/icon/jfsc-new.png"),
                    wd_new:require("@assets/images/classChannel/icon/wd-new.png")
                };
                // console.log("ck:::::"+ck)
                if(ck){
                    return thumb[type1];
                }else{
                    return thumb[type];
                }

            },
            getColor(ck){
                if(ck){
                    return "#003eab";
                }else{
                    return "white";
                }
            }
        }
    };
</script>
